
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SelectOption } from '../../../../../components/base/BaseSelect.vue'

@Component
export default class WithinInput extends Vue {
  @Prop({ required: true, type: Number })
    value: number

  get valueOrDefault() {
    return this.value || this.$config.public.defaultWithinRange
  }

  selectionChanged(selection: { selectedValue: string }) {
    const range = Number(selection.selectedValue)
    const result = isNaN(range) ? this.$config.public.defaultWithinRange : range
    this.$emit('input', result)
  }

  get selectOptions() {
    const options: SelectOption[] = []
    const maxValue = 95
    const currentValue = Math.min(this.valueOrDefault, maxValue)
    const step = 5
    for (let value = 5; value <= maxValue; value += step) {
      options.push(this.formatOption(value))
    }
    // if the current value not in the list, let's add it
    if (!options.some((option) => option.value === currentValue.toString())) {
      options.push(this.formatOption(currentValue))
      options.sort((a, b) => Number(a.value) - Number(b.value))
    }
    return options
  }

  formatOption(value: number): SelectOption {
    return {
      value: value.toString(),
      name: this.$t('{value, localeDistance, long}', { value }) as string,
      // would be better to pass selected as a value to the top
      selected: value === this.valueOrDefault,
    }
  }
}
